import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { toNowTime } from '@peloton/time';
import { getClassDetails, getFeatureModules, getOnDemandClasses, getRideTimeline, getScheduledClasses } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
/**
 * This is the time bound for fetching live classes. We are assuming the longest
 * possible class is 120 minutes.
 */

var MAX_COURSE_LENGTH = 120;

var toScheduleStartTime = function toScheduleStartTime() {
  return toNowTime().clone().subtract(MAX_COURSE_LENGTH, 'm').unix();
};

var toScheduleEndTime = function toScheduleEndTime() {
  return toNowTime().clone().add(MAX_COURSE_LENGTH, 'm').unix();
};

var searchClassKeyPrefix = 'SearchClasses';
export var extractParamsFromSearchClassKey = function extractParamsFromSearchClassKey(key) {
  var paramsAsJSON = key.split(searchClassKeyPrefix)[1];

  try {
    var params = JSON.parse(paramsAsJSON);
    return params;
  } catch (e) {
    return {};
  }
};
export var classFetcherFeaturedClassesKey = 'FeaturedClasses';
export var toClassFetchers = function toClassFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    GetClassById: toFetcher(function (params) {
      return "GetClass".concat(params.classId);
    }, function (params) {
      return unwrap(function () {
        return !!(params !== null && params !== void 0 && params.shouldSkipFetch) ? new Promise(function () {
          return null;
        }) : getClassDetails(api, params.classId);
      });
    }),
    SearchClasses: toFetcher(function (_, params) {
      return "".concat(searchClassKeyPrefix).concat(JSON.stringify(params));
    }, function (_, params) {
      return unwrap(function () {
        return getOnDemandClasses(api, 'web', params.acceptLanguage || 'en-us', params.classTypeId, 'peloton', params.contentFormat, params.duration, params.fitnessDiscipline, params.browseCategory, params.hasWorkout, params.instructorId, params.isFavoriteRide, params.isFollowingUserRide, undefined, params.language, params.rideTypeId, params.superGenreId, params.limit, params.page, params.hasCyclingArms, params.sortBy, params.desc, params.hasClosedCaptions, params.captionLocales, params.classLanguages, params.ignoreClassLanguagePreferences, params.hasFreeMode, {
          query: _defineProperty({}, 'difficulty_level', params.difficultyLevel)
        });
      });
    }),
    GetTimelineByClassId: toFetcher(function (params) {
      return "GetTimelineByClassId".concat(params.classId);
    }, function (params) {
      return unwrap(function () {
        return getRideTimeline(api, params.classId);
      });
    }, {
      dedupingInterval: 30 * 1000 // 30 Seconds

    }),
    GetFeaturedClasses: toFetcher(function (_) {
      return classFetcherFeaturedClassesKey;
    }, function (req) {
      return unwrap(function () {
        return getFeatureModules(api, req.pelotonPlatform, req.acceptLanguage, req.pelotonClientDate ? {
          headers: {
            'Peloton-Client-Date': req.pelotonClientDate
          }
        } : undefined);
      });
    }),
    // keeping this separate for WebTV to limit changes for potential bugs
    GetUpcomingLiveClassesWebTV: toFetcher(function (_) {
      return 'UpcomingLiveClasses';
    }, function (req) {
      return unwrap(function () {
        return getScheduledClasses(api, req.pelotonPlatform, undefined, toScheduleStartTime(), toScheduleEndTime(), undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, true);
      });
    }),
    GetUpcomingLiveClasses: toFetcher(function (_) {
      return 'UpcomingLiveClasses';
    }, function (req) {
      return unwrap(function () {
        return getScheduledClasses(api, req.pelotonPlatform, undefined, req.start, undefined, undefined, undefined, undefined, undefined, undefined, req.limit, req.excludeComplete, undefined, undefined, undefined, undefined, undefined, req.excludeLiveInStudioOnly);
      });
    })
  };
};